/* =================================================================
   br-faq-cards — the donor's expand motion, re-implemented in vanilla
   JS over native <details>/<summary>.

   WHY JS AT ALL: the markup is details/summary, which toggles instantly
   and cannot animate height — and the &Fold faq-1 interaction IS the
   animation (measured from the donor's IX2, homepage/home-c.html):
     open  — height 0 → auto 400ms easeOut,
             opacity 0 → 1 300ms easeOut after a 100ms delay,
             icon bar rotates to − 300ms easeOut (pure CSS, [open])
     close — height/opacity/rotate all 300ms easeOut, no delay
   Items are independent — opening one never closes a sibling.

   This file is a progressive enhancement, exactly like
   br-science-fuels.js: without it (or with prefers-reduced-motion) the
   cards still open and close natively — they just snap. No libraries,
   no donor runtime; two WAAPI animations per toggle.
   ================================================================= */
(function () {
  /* This script is loaded per br-faq-cards section, and the theme editor
     re-executes section scripts on re-render. A re-run would double-bind
     the document listener below — two handlers would toggle the same
     click, so the item opens and instantly closes. Run once. */
  if (window.__brFaqCardsInit) return;
  window.__brFaqCardsInit = true;

  /* Donor-measured timings. 400ms sits between the theme's duration
     tokens (300/450), so the measured values stay literal. */
  var OPEN_HEIGHT_MS = 400;
  var OPEN_OPACITY_MS = 300;
  var OPEN_OPACITY_DELAY_MS = 100;
  var CLOSE_MS = 300;
  var EASE_OUT = 'cubic-bezier(0, 0, 0.2, 1)'; /* --bt-ease-out */

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function cancelAnimations(panel) {
    panel.getAnimations().forEach(function (animation) {
      animation.cancel();
    });
  }

  function openItem(item, panel) {
    /* Read the in-flight height/opacity BEFORE cancelling, so a click
       mid-close reverses smoothly from where the card actually is. */
    var computed = getComputedStyle(panel);
    var startHeight = item.open ? computed.height : '0px';
    var startOpacity = item.open ? computed.opacity : '0';
    cancelAnimations(panel);

    item.open = true; /* content must render before we can measure it */
    var fullHeight = panel.scrollHeight + 'px';

    panel.animate([{ height: startHeight }, { height: fullHeight }], {
      duration: OPEN_HEIGHT_MS,
      easing: EASE_OUT,
    });
    panel.animate([{ opacity: startOpacity }, { opacity: '1' }], {
      duration: OPEN_OPACITY_MS,
      delay: OPEN_OPACITY_DELAY_MS,
      easing: EASE_OUT,
      fill: 'backwards' /* hold the start opacity through the delay */,
    });
    /* End state needs no fill: an open <details> shows the panel at
       natural height and full opacity on its own. */
  }

  function closeItem(item, panel) {
    var computed = getComputedStyle(panel);
    var startHeight = computed.height;
    var startOpacity = computed.opacity;
    cancelAnimations(panel);

    var heightAnimation = panel.animate([{ height: startHeight }, { height: '0px' }], {
      duration: CLOSE_MS,
      easing: EASE_OUT,
      fill: 'forwards',
    });
    panel.animate([{ opacity: startOpacity }, { opacity: '0' }], {
      duration: CLOSE_MS,
      easing: EASE_OUT,
      fill: 'forwards',
    });

    heightAnimation.finished
      .then(function () {
        item.open = false; /* a closed <details> hides the panel natively */
        cancelAnimations(panel);
      })
      .catch(function () {
        /* Animation was cancelled by a re-open — nothing to do. */
      });
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.br-faq-cards__question');
    if (!summary) return;

    var item = summary.parentElement;
    var panel = item.querySelector('.br-faq-cards__answer');
    if (!panel || typeof panel.animate !== 'function' || reduceMotion.matches) {
      return; /* native instant toggle — keyboard and AT paths included */
    }

    /* Take over the toggle so `open` flips at the RIGHT end of the
       animation (immediately on open, at height 0 on close). Keyboard
       Enter/Space on a summary fires click too, so this covers both. */
    event.preventDefault();

    if (item.open) {
      closeItem(item, panel);
    } else {
      openItem(item, panel);
    }
  });
})();
